import player14 from '@assets/players/14.webp';
import player9 from '@assets/players/9.webp';
import player11 from '@assets/players/11.webp';
import player8 from '@assets/players/8.webp';
import player25 from '@assets/players/25.webp';
import player10 from '@assets/players/10.webp';
import player2 from '@assets/players/2.webp';
import player4 from '@assets/players/4.webp';
import player5 from '@assets/players/5.webp';
import player12 from '@assets/players/12.webp';
import player1 from '@assets/players/1.webp';

const defaults = [
    {
        number: 9,
        avatar: player9,
        role: 'center-forward',
        name: 'center'
    },
    {
        number: 8,
        avatar: player8,
        role: 'center-midfielder-left',
        name: 'center-left'
    },
    {
        number: 10,
        avatar: player10,
        role: 'center-midfielder-right',
        name: 'center-right'
    },

    {
        number: 4,
        avatar: player4,
        role: 'center-back-left',
        name: 'center-back-left'
    },
    {
        number: 5,
        avatar: player5,
        role: 'center-back-right',
        name: 'center-back-right'
    },
    {
        number: 1,
        avatar: player1,
        role: 'keeper',
        name: 'keeper'
    }
]

export default defaults